import baseClasses from '@components/Themes/layout.module.scss'
import TopPageAboutUs from '@components/TopPageAboutUs'
import Typography from '@mui/material/Typography'
import { loadSeccionfinanzas, searchSeccionfinanzas } from '@store/actions/seccionfinanzasActions'
import { loadSeccionits, searchSeccionits } from '@store/actions/seccionitsActions'
import { loadSeccionmarketings, searchSeccionmarketings } from '@store/actions/seccionmarketingsActions'
import { loadSeccionsocios, searchSeccionsocios } from '@store/actions/seccionsociosActions'
import { loadSeccionturismos, searchSeccionturismos } from '@store/actions/seccionturismosActions'
import { IState } from '@store/reducers/index'
import AboutUsmodulescss from 'dist/css/AboutUs.module.scss'
import React, { FunctionComponent } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'

const AboutUs: FunctionComponent = (props: any) => {
  const {
    history: navigation,
    match: { params },
  } = props
  const classes = baseClasses
  const dataFinanzas = useSelector((state: IState) => state.seccionfinanzas).seccionfinanzas
  const seccionfinanzasData = useSelector((state: IState) => state.seccionfinanzas)
  const dataMarketing = useSelector((state: IState) => state.seccionmarketings).seccionmarketings
  const seccionmarketingsData = useSelector((state: IState) => state.seccionmarketings)
  const dataTurismo = useSelector((state: IState) => state.seccionturismos).seccionturismos
  const seccionturismosData = useSelector((state: IState) => state.seccionturismos)
  const dataIT = useSelector((state: IState) => state.seccionits).seccionits
  const seccionitsData = useSelector((state: IState) => state.seccionits)
  const dataSocios = useSelector((state: IState) => state.seccionsocios).seccionsocios
  const seccionsociosData = useSelector((state: IState) => state.seccionsocios)
  const theme = { ...baseClasses, ...AboutUsmodulescss }
  const dispatch = useDispatch()
  const [LoadfromDatabaseSociosloadoptions, setLoadfromDatabaseSociosloadoptions] = React.useState<any>({
    page: 1,
    populate: true,
    limit: 25,
    sort: { field: null, method: 'DESC' },
    totalItems: 0,
    sortLanguage: 'en',
  })
  const performLoadfromDatabaseSociosload = (options) => {
    dispatch(options.searchString ? searchSeccionsocios(options) : loadSeccionsocios(options))
  }
  React.useEffect(() => {
    performLoadfromDatabaseSociosload({
      ...LoadfromDatabaseSociosloadoptions,
    })
  }, [LoadfromDatabaseSociosloadoptions])
  const [LoadfromDatabaseITloadoptions, setLoadfromDatabaseITloadoptions] = React.useState<any>({
    page: 1,
    populate: true,
    limit: 25,
    sort: { field: null, method: 'DESC' },
    totalItems: 0,
    sortLanguage: 'en',
  })
  const performLoadfromDatabaseITload = (options) => {
    dispatch(options.searchString ? searchSeccionits(options) : loadSeccionits(options))
  }
  React.useEffect(() => {
    performLoadfromDatabaseITload({
      ...LoadfromDatabaseITloadoptions,
    })
  }, [LoadfromDatabaseITloadoptions])
  const [LoadfromDatabaseTurismoloadoptions, setLoadfromDatabaseTurismoloadoptions] = React.useState<any>({
    page: 1,
    populate: true,
    limit: 25,
    sort: { field: null, method: 'DESC' },
    totalItems: 0,
    sortLanguage: 'en',
  })
  const performLoadfromDatabaseTurismoload = (options) => {
    dispatch(options.searchString ? searchSeccionturismos(options) : loadSeccionturismos(options))
  }
  React.useEffect(() => {
    performLoadfromDatabaseTurismoload({
      ...LoadfromDatabaseTurismoloadoptions,
    })
  }, [LoadfromDatabaseTurismoloadoptions])
  const [LoadfromDatabaseMarketingloadoptions, setLoadfromDatabaseMarketingloadoptions] = React.useState<any>({
    page: 1,
    populate: true,
    limit: 25,
    sort: { field: null, method: 'DESC' },
    totalItems: 0,
    sortLanguage: 'en',
  })
  const performLoadfromDatabaseMarketingload = (options) => {
    dispatch(options.searchString ? searchSeccionmarketings(options) : loadSeccionmarketings(options))
  }
  React.useEffect(() => {
    performLoadfromDatabaseMarketingload({
      ...LoadfromDatabaseMarketingloadoptions,
    })
  }, [LoadfromDatabaseMarketingloadoptions])
  const [LoadfromDatabaseFinanzasloadoptions, setLoadfromDatabaseFinanzasloadoptions] = React.useState<any>({
    page: 1,
    populate: true,
    limit: 25,
    sort: { field: null, method: 'DESC' },
    totalItems: 0,
    sortLanguage: 'en',
  })
  const performLoadfromDatabaseFinanzasload = (options) => {
    dispatch(options.searchString ? searchSeccionfinanzas(options) : loadSeccionfinanzas(options))
  }
  React.useEffect(() => {
    performLoadfromDatabaseFinanzasload({
      ...LoadfromDatabaseFinanzasloadoptions,
    })
  }, [LoadfromDatabaseFinanzasloadoptions])

  // Theme selection

  return (
    <React.Fragment>
      <div className={classes.mainPanel}>
        <div data-title="topPage" className={theme.topPage}>
          <TopPageAboutUs />
        </div>

        <div data-title="div container" className={theme.container}>
          <div data-title="Title rework" className={theme.titleRedRework}>
            <Typography variant="h6">NUESTRA FILOSOFÍA</Typography>

            <Typography variant="body1">
              «Creemos en la riqueza y que el legado de un destino se encuentra en su gente, por lo que facilitamos y hacemos memorable el intercambio
              cultural entre viajeros y anfitriones locales, utilizando tecnología que otorgue una amplia visualización del destino».
            </Typography>
          </div>

          <div data-title="div Socios" className={theme.divSeccionesCards}>
            <div data-title="Title " className={theme.titleRed}>
              <Typography variant="h6">Socios</Typography>
            </div>

            <div data-title=" all Cards" className={theme.allCards}>
              <div data-title="Card Posts DB" className={theme.allCards}>
                {dataSocios.map((item, index) => {
                  return (
                    <React.Fragment key={'TJNCp65p_' + index}>
                      <div data-title="div loop Every card" className={theme.everyCard}>
                        <div data-title="div cardsEmployeeImg" className={theme.cardsEmployeeImg}>
                          <picture className={theme.mainImage}>
                            <img src={`/img/${item.Picture}`} alt={`/img/${item.Picture}`} />
                          </picture>
                        </div>

                        <div data-title="div cardsEmployeeNamesAndRole" className={theme.cardsEmployeeNames}>
                          <div data-title="Name and LastName" className={theme.employeeNames}>
                            <Typography variant="h6">{item.Name}</Typography>

                            <Typography variant="h6">{item.LastName}</Typography>
                          </div>

                          <div data-title="Role" className={theme.employeeRole}>
                            <Typography variant="h6">{item.Role}</Typography>
                          </div>
                        </div>

                        <div data-title="div cardsEmployeeLinks" className={theme.cardsEmployeeLinks}>
                          <div data-title="Socials Links" className={theme.cardsTDDescriptionTop}>
                            <a target="_top" href={item.LinkedIn} draggable={false}>
                              <picture>
                                <img src="/img/LogoLinkedin.svg" alt="/img/LogoLinkedin.svg" />
                              </picture>
                            </a>

                            <a target="_top" href={item.Email} draggable={false}>
                              <picture>
                                <img src="/img/LogoMail.svg" alt="/img/LogoMail.svg" />
                              </picture>
                            </a>
                          </div>
                        </div>
                      </div>
                    </React.Fragment>
                  )
                })}
              </div>
            </div>
          </div>

          <div data-title="div IT" className={theme.divSeccionesCards}>
            <div data-title="Title " className={theme.titleRed}>
              <Typography variant="h6">IT</Typography>
            </div>

            <div data-title=" all Cards" className={theme.allCards}>
              <div data-title="Card Posts DB" className={theme.allCards}>
                {dataIT.map((item, index) => {
                  return (
                    <React.Fragment key={'OnTPuSGu_' + index}>
                      <div data-title="div loop Every card" className={theme.everyCard}>
                        <div data-title="div cardsEmployeeImg" className={theme.cardsEmployeeImg}>
                          <picture className={theme.mainImage}>
                            <img src={`/img/${item.Picture}`} alt={`/img/${item.Picture}`} />
                          </picture>
                        </div>

                        <div data-title="div cardsEmployeeNamesAndRole" className={theme.cardsEmployeeNames}>
                          <div data-title="Name and LastName" className={theme.employeeNames}>
                            <Typography variant="h6">{item.Name}</Typography>

                            <Typography variant="h6">{item.LastName}</Typography>
                          </div>

                          <div data-title="Role" className={theme.employeeRole}>
                            <Typography variant="h6">{item.Role}</Typography>
                          </div>
                        </div>

                        <div data-title="div cardsEmployeeLinks" className={theme.cardsEmployeeLinks}>
                          <div data-title="Socials Links" className={theme.cardsTDDescriptionTop}>
                            <a target="_top" href={item.LinkedIn} draggable={false}>
                              <picture>
                                <img src="/img/LogoLinkedin.svg" alt="/img/LogoLinkedin.svg" />
                              </picture>
                            </a>

                            <a target="_top" href={item.Email} draggable={false}>
                              <picture>
                                <img src="/img/LogoMail.svg" alt="/img/LogoMail.svg" />
                              </picture>
                            </a>
                          </div>
                        </div>
                      </div>
                    </React.Fragment>
                  )
                })}
              </div>
            </div>
          </div>

          <div data-title="div Turismo" className={theme.divSeccionesCards}>
            <div data-title="Title " className={theme.titleRed}>
              <Typography variant="h6">Turismo</Typography>
            </div>

            <div data-title=" all Cards" className={theme.allCards}>
              <div data-title="Card Posts DB" className={theme.allCards}>
                {dataTurismo.map((item, index) => {
                  return (
                    <React.Fragment key={'6coR4cTN_' + index}>
                      <div data-title="div loop Every card" className={theme.everyCard}>
                        <div data-title="div cardsEmployeeImg" className={theme.cardsEmployeeImg}>
                          <picture className={theme.mainImage}>
                            <img src={`/img/${item.Picture}`} alt={`/img/${item.Picture}`} />
                          </picture>
                        </div>

                        <div data-title="div cardsEmployeeNamesAndRole" className={theme.cardsEmployeeNames}>
                          <div data-title="Name and LastName" className={theme.employeeNames}>
                            <Typography variant="h6">{item.Name}</Typography>

                            <Typography variant="h6">{item.LastName}</Typography>
                          </div>

                          <div data-title="Role" className={theme.employeeRole}>
                            <Typography variant="h6">{item.Role}</Typography>
                          </div>
                        </div>

                        <div data-title="div cardsEmployeeLinks" className={theme.cardsEmployeeLinks}>
                          <div data-title="Socials Links" className={theme.cardsTDDescriptionTop}>
                            <a target="_top" href={item.LinkedIn} draggable={false}>
                              <picture>
                                <img src="/img/LogoLinkedin.svg" alt="/img/LogoLinkedin.svg" />
                              </picture>
                            </a>

                            <a target="_top" href={item.Email} draggable={false}>
                              <picture>
                                <img src="/img/LogoMail.svg" alt="/img/LogoMail.svg" />
                              </picture>
                            </a>
                          </div>
                        </div>
                      </div>
                    </React.Fragment>
                  )
                })}
              </div>
            </div>
          </div>

          <div data-title="div Marketing" className={theme.divSeccionesCards}>
            <div data-title="Title " className={theme.titleRed}>
              <Typography variant="h6">Marketing</Typography>
            </div>

            <div data-title=" all Cards" className={theme.allCards}>
              <div data-title="Card Posts DB" className={theme.allCards}>
                {dataMarketing.map((item, index) => {
                  return (
                    <React.Fragment key={'cIGZD47c_' + index}>
                      <div data-title="div loop Every card" className={theme.everyCard}>
                        <div data-title="div cardsEmployeeImg" className={theme.cardsEmployeeImg}>
                          <picture className={theme.mainImage}>
                            <img src={`/img/${item.Picture}`} alt={`/img/${item.Picture}`} />
                          </picture>
                        </div>

                        <div data-title="div cardsEmployeeNamesAndRole" className={theme.cardsEmployeeNames}>
                          <div data-title="Name and LastName" className={theme.employeeNames}>
                            <Typography variant="h6">{item.Name}</Typography>

                            <Typography variant="h6">{item.LastName}</Typography>
                          </div>

                          <div data-title="Role" className={theme.employeeRole}>
                            <Typography variant="h6">{item.Role}</Typography>
                          </div>
                        </div>

                        <div data-title="div cardsEmployeeLinks" className={theme.cardsEmployeeLinks}>
                          <div data-title="Socials Links" className={theme.cardsTDDescriptionTop}>
                            <a target="_top" href={item.LinkedIn} draggable={false}>
                              <picture>
                                <img src="/img/LogoLinkedin.svg" alt="/img/LogoLinkedin.svg" />
                              </picture>
                            </a>

                            <a target="_top" href={item.Email} draggable={false}>
                              <picture>
                                <img src="/img/LogoMail.svg" alt="/img/LogoMail.svg" />
                              </picture>
                            </a>
                          </div>
                        </div>
                      </div>
                    </React.Fragment>
                  )
                })}
              </div>
            </div>
          </div>

          <div data-title="div Finanzas" className={theme.divSeccionesCards}>
            <div data-title="Title " className={theme.titleRed}>
              <Typography variant="h6">Finanzas</Typography>
            </div>

            <div data-title=" all Cards" className={theme.allCards}>
              <div data-title="Card Posts DB" className={theme.allCards}>
                {dataFinanzas.map((item, index) => {
                  return (
                    <React.Fragment key={'X7zvN7u7_' + index}>
                      <div data-title="div loop Every card" className={theme.everyCard}>
                        <div data-title="div cardsEmployeeImg" className={theme.cardsEmployeeImg}>
                          <picture className={theme.mainImage}>
                            <img src={`/img/${item.Picture}`} alt={`/img/${item.Picture}`} />
                          </picture>
                        </div>

                        <div data-title="div cardsEmployeeNamesAndRole" className={theme.cardsEmployeeNames}>
                          <div data-title="Name and LastName" className={theme.employeeNames}>
                            <Typography variant="h6">{item.Name}</Typography>

                            <Typography variant="h6">{item.LastName}</Typography>
                          </div>

                          <div data-title="Role" className={theme.employeeRole}>
                            <Typography variant="h6">{item.Role}</Typography>
                          </div>
                        </div>

                        <div data-title="div cardsEmployeeLinks" className={theme.cardsEmployeeLinks}>
                          <div data-title="Socials Links" className={theme.cardsTDDescriptionTop}>
                            <a target="_top" href={item.LinkedIn} draggable={false}>
                              <picture>
                                <img src="/img/LogoLinkedin.svg" alt="/img/LogoLinkedin.svg" />
                              </picture>
                            </a>

                            <a target="_top" href={item.Email} draggable={false}>
                              <picture>
                                <img src="/img/LogoMail.svg" alt="/img/LogoMail.svg" />
                              </picture>
                            </a>
                          </div>
                        </div>
                      </div>
                    </React.Fragment>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div data-title="Footer Red" className={theme.footersRed}>
        <div data-title="div footer Left" className={theme.footerDivLeft}>
          <div data-title="div Img And Buttons Socials" className={theme.footerImgSocials}>
            <div data-title="div Img" className={theme.footerImg}>
              <picture>
                <img src="/img/RTLogo_blanco.svg" alt="/img/RTLogo_blanco.svg" />
              </picture>
            </div>

            <div data-title="div buttons socials" className={theme.footerButtonsSocials}>
              <a target="_blank" href="https://www.linkedin.com/company/realtravel/">
                <picture>
                  <img src="/img/LogoLinkedin.svg" alt="/img/LogoLinkedin.svg" />
                </picture>
              </a>

              <a href="mailto:hola@realtravel.cl?subject=Email%20de%20contacto%20por%20&body=Hola!%20Me%20contacto%20desde%20el%20website%20de%20Real%20Travel%20para%3A%20">
                <picture>
                  <img src="/img/LogoMail.svg" alt="/img/LogoMail.svg" />
                </picture>
              </a>

              <a target="_blank" href="https://www.instagram.com/realtravelap/">
                <picture>
                  <img src="/img/LogoIntagram.svg" alt="/img/LogoIntagram.svg" />
                </picture>
              </a>

              <a target="_blank" href="https://www.youtube.com/channel/UC535xN03fixDzJGFtVDAtvA/featured">
                <picture>
                  <img src="/img/logoYouTube.svg" alt="/img/logoYouTube.svg" />
                </picture>
              </a>
            </div>
          </div>

          <div data-title="div All rights reserved" className={theme.footerAllRightsReserved}>
            <Typography variant="body1">©2024 Real Travel. All rights reserved</Typography>
          </div>
        </div>

        <div data-title="div links" className={theme.footerDivCenter}>
          <NavLink to="/AboutUs">
            <Typography variant="h6">Quienes somos</Typography>
          </NavLink>

          <NavLink to="/JoinUs">
            <Typography variant="h6">Se parte</Typography>
          </NavLink>

          <NavLink to="/Press">
            <Typography variant="h6">Prensa</Typography>
          </NavLink>
        </div>

        <div data-title="Div Footer  Right" className={theme.footerDivRight}>
          <div data-title="div terms and conditions" className={theme.footerTermsAndConditions}>
            <NavLink to="/TermsAndConditions">
              <Typography variant="body1">Términos y condiciones</Typography>
            </NavLink>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default AboutUs
